import { createContext, useContext, useState } from 'react'
import { getSession, setSession as persistSession } from './adminApi.js'

const AdminAuthContext = createContext(null)

export function AdminAuthProvider({ children }) {
  const [session, setSessionState] = useState(() => getSession())

  const login = (sessionData) => {
    persistSession(sessionData)
    setSessionState(sessionData)
  }
  const logoutLocal = () => {
    persistSession(null)
    setSessionState(null)
  }

  return (
    <AdminAuthContext.Provider value={{ session, isAuthed: !!session, login, logoutLocal }}>
      {children}
    </AdminAuthContext.Provider>
  )
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext)
  if (!ctx) throw new Error('Must be used within <AdminAuthProvider>')
  return ctx
}
